import { SET_CHART_INTERVAL, SET_CHART_THEME } from '../actions/types';

const initialState = {
  interval: JSON.parse(localStorage.getItem('chart-interval')) || 'D',
  darkMode: JSON.parse(localStorage.getItem('chart-theme')) ?? true,
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_CHART_INTERVAL:
      return { ...state, interval: payload };
    case SET_CHART_THEME:
      return { ...state, darkMode: payload };
    default:
      return state;
  }
}
